/**
 * Bulk export / Alfresco SmartLink import constants.
 * Alfresco makes no vendor distinction during import; these values are required by spec.
 */
export const ALFRESCO_THREE_PI_VENDOR = 'PVS-LTI-1.3';

/** Naming convention: export file name must begin with this prefix. */
export const ALFRESCO_EXPORT_FILENAME_PREFIX = 'sl_3rd_party';

/** Default export filename when server does not send Content-Disposition. */
export const ALFRESCO_EXPORT_DEFAULT_FILENAME = `${ALFRESCO_EXPORT_FILENAME_PREFIX}.csv`;

export interface BulkExportLinkItem {
  title: string;
  externalUrlLink: string;
  threePIVendor: string;
}

export interface BulkExportLinksRequest {
  links: BulkExportLinkItem[];
}
